import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'salesChatsList/state',
    initialState: {
        deleteConfirmation: false,
        selectedChatId: '',
        sortedColumn: () => {},
        conversationModalOpen: false,
    },
    reducers: {
        setDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSelectedChatId: (state, action) => {
            state.selectedChatId = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setConversationModalOpen: (state, action) => {
            state.conversationModalOpen = action.payload
        },
    },
})

export const {
    setDeleteConfirmation,
    setSelectedChatId,
    setSortedColumn,
    setConversationModalOpen,
} = stateSlice.actions

export default stateSlice.reducer 